import { createFileRoute } from '@tanstack/react-router'
import { OptimizationOpportunityDetail } from '@/features/optimization/detail'
import { opportunityDetailSearchSchema } from '@/features/optimization/navigation'

export const Route = createFileRoute(
  '/_authenticated/optimization/opportunities/$opportunityId'
)({
  validateSearch: opportunityDetailSearchSchema,
  component: OptimizationOpportunityDetail,
})
